import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-pdf-page',
  components: {},
})
export default class PdfPage extends Vue {
  @Prop(Boolean) readonly withHeader: boolean;
  @Prop({ type: Number, default: 349 }) readonly headerHeight: number; // heigth in px
  @Prop(Boolean) readonly withFooter: boolean;
  @Prop({ type: Number, default: 200 }) readonly footerHeight: number; // heigth in px
  @Prop({ type: Number, default: 1089 }) readonly pageHeight: number; // in px
  @Prop({ type: Number, default: 770 }) readonly pageWidth: number; // in px
  @Prop({ type: Number, default: 30 }) readonly padding: number; // in px
  @Prop(Boolean) readonly debug: boolean;

  get contentHeightPx(): string {
    let finalHeight = this.pageHeight - 2 * this.padding;

    if (this.withHeader) {
      finalHeight = finalHeight - this.headerHeight - this.padding;
    }

    if (this.withFooter) {
      finalHeight = finalHeight - this.footerHeight - this.padding;
    }

    return `${finalHeight}px`;
  }

  get paddingPx(): string {
    return `${this.padding}px`;
  }

  get headerHeightPx(): string {
    return `${this.headerHeight}px`;
  }

  get footerHeightPx(): string {
    return `${this.footerHeight}px`;
  }

  get pageHeightPx(): string {
    return `${this.pageHeight}px`;
  }
  get pageWidthPx(): string {
    return `${this.pageWidth}px`;
  }

  // get Margins(): string {
  //   return this.withHeader ? `${this.paddingPx} 0` : `0`;
  // }

  get printPageExtraClasses(): Record<string, boolean> {
    return {
      'print-page': true,
      'print-page__first-page': !!this.withHeader,
      'print-page__common-page': !this.withHeader,
    };
  }

  get pageStyle(): Record<string, string> {
    return {
      height: this.pageHeightPx,
      minWidth: this.pageWidthPx,
      padding: this.paddingPx,
      display: 'block',
      position: 'relative',
      'background-color': this.debug ? '#cccccc' : 'transparent',
    };
  }

  get contentStyle(): Record<string, string> {
    return {
      height: this.contentHeightPx,
      margin: '0',
      position: 'relative',
      'background-color': this.debug ? '#bfe8e8' : 'transparent',
    };
  }

  get headerStyle(): Record<string, string> {
    return {
      height: this.headerHeightPx,
      position: 'relative',
      'margin-bottom': this.paddingPx,
      'background-color': this.debug ? '#deb887' : 'transparent',
    };
  }

  get footerStyle(): Record<string, string> {
    return {
      // height: this.footerHeightPx,
      // position: 'relative',
      // 'margin-top': this.paddingPx,
      // 'background-color': this.debug ? '#bfe8c1' : 'transparent',
    };
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
